/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_F6_QInputs */

const en_mk_sec_pg_f6_q = /** @type {(inputs: Mk_Sec_Pg_F6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I see what an agent did last week?`)
};

const id_mk_sec_pg_f6_q = /** @type {(inputs: Mk_Sec_Pg_F6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisakah saya melihat apa yang dilakukan agen minggu lalu?`)
};

/**
* | output |
* | --- |
* | "Can I see what an agent did last week?" |
*
* @param {Mk_Sec_Pg_F6_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_f6_q = /** @type {((inputs?: Mk_Sec_Pg_F6_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_F6_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_f6_q(inputs)
	return en_mk_sec_pg_f6_q(inputs)
});